import CONFIG from './../config';
import {
  ApolloClient,
  InMemoryCache,
  split,
  useMutation as useMutationHookForm,
  useQuery as useQueryHookForm,
} from '@apollo/client';
import { BatchHttpLink } from '@apollo/client/link/batch-http'; // ✅ use BatchHttpLink
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { getMainDefinition } from '@apollo/client/utilities';
import { setContext } from '@apollo/client/link/context';
import { getUser } from '../features/auth/hooks/useAuth';
import Cookies from 'js-cookie';

const API_PORT = String(CONFIG.API_PORT || '').trim();
const API_HOST = API_PORT ? `${CONFIG.API_BASE_URL}:${API_PORT}` : CONFIG.API_BASE_URL;
const GRAPHQL_URL = `${API_HOST}/graphql`;
const WS_PROTOCOL = CONFIG.API_PROTOCOL === 'https' ? 'wss' : 'ws';
const GRAPHQL_HEADERS = CONFIG.GRAPHQL_SECRET ? { 'x-hasura-admin-secret': CONFIG.GRAPHQL_SECRET } : {};

const wsLink = new GraphQLWsLink({
  uri: `${WS_PROTOCOL}://${GRAPHQL_URL}`,
  options: {
    reconnect: true,
    timeout: 30000,
    connectionParams: {
      headers: GRAPHQL_HEADERS,
    },
  },
});

const batchHttpLink = new BatchHttpLink({
  uri: `${CONFIG.GRAPHQL_PROTOCOL}://${GRAPHQL_URL}`,
  credentials: 'include',
  batchInterval: 10,
  batchMax: 50,
});

const authLink = setContext(async (_, { headers }) => {
  let user = getUser();
  const csrfToken = Cookies.get('XSRF-TOKEN');

  const newHeaders = {
    ...GRAPHQL_HEADERS,
    ...headers,
    "Accept": "application/json",
    "X-XSRF-TOKEN": csrfToken,
  };

  if (user?._token) {
    newHeaders["Authorization"] = `Bearer ${user._token}`;
  }

  return { headers: newHeaders };
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  batchHttpLink
);

const clientGraphql = new ApolloClient({
  link: authLink.concat(splitLink),
  cache: new InMemoryCache(),
});

export const useMutation = (gql, options = {}) =>
  useMutationHookForm(gql, { ...options, client: clientGraphql });

export const useQuery = (gql, options = {}) =>
  useQueryHookForm(gql, { ...options, client: clientGraphql });

export default clientGraphql;
